<script>
  import Zooming from "zooming";
  import { onMount, tick } from "svelte";
  import { fly } from "svelte/transition";
  import { fade } from "svelte/transition";
  import Button from "./Button.svelte";
  import EditButton from "./EditButton.svelte";
  import { createEventDispatcher } from "svelte";
  import { v4 as uuidv4 } from 'uuid';
  
  
  import Delete16 from "carbon-icons-svelte/lib/Delete16";
  
  import firebase from "@firebase/app";
  import FileUpload from "sveltefileuploadcomponent";
  import Loader from "./Loader.svelte";

  import "@firebase/storage";

  const storageRef = firebase.storage().ref();

  const dispatch = createEventDispatcher();

  export let thumb = null;
  export let thumbName = null;
  let newImg = thumb;
  let visible = false;
  let imgEl;
  let uploading = false;

  async function upload(e) {
  console.log(e.detail.files);
  if (e.detail.files) {
    const file = e.detail.files;
    uploading = true;

    // Generate a unique file name
    const fileExtension = file.name.split('.').pop();
    const randomFileName = `${uuidv4()}.${fileExtension}`;

    // Create a random path (e.g., 'images/2024/07/01/')
    const date = new Date();
    const randomPath = `images/${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;

    // Combine path and file name
    const fullPath = `${randomPath}/${randomFileName}`;

    await storageRef.child(fullPath).put(file);
    thumb = await storageRef.child(fullPath).getDownloadURL();
    thumbName = fullPath;
    uploading = false;
  }
}

  function forwardEvent(event) {
    dispatch("message");
  }

  async function deleteImage() {
    thumb = null;
    await storageRef.child(thumbName).delete();
    thumbName = null;
  }
</script>

<div class="border-r h-full">
  {#if !thumb}
    <div class="p-2 h-full">
      {#if !uploading}
        <FileUpload on:input={upload} multiple={false}>
          <div class="dropzone h-full flex">
            <div class="self-center">
              <p class="text-xs px-4 text-center">
                Drag image or click to upload
              </p>
            </div>
          </div>
        </FileUpload>
      {:else}
        <div class="dropzone">
          <Loader fullScreen={false} />
        </div>
      {/if}
    </div>
  {:else}
    <div class="">
      <div class="image mapthumb" data-src={thumb}>
        <img
          title={thumbName}
          bind:this={imgEl}
          src={thumb}
          alt=""
          data-zoomable
          data-original={thumb}
        />

        <div
          class="deleteIcon"
          on:click={() => {
            deleteImage(thumbName);
          }}
        >
          <Delete16 style="fill: white" />
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  .dropzone {
    @apply rounded border-2 border-gray-200 border-dashed text-center cursor-pointer p-4;
  }
  :global(.dragging .dropzone) {
    @apply border-mapblue border-2;
  }
  .dropzone:hover {
    @apply border-mapblue border-2;
  }

  .dropzone p {
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
  }

  .dragging .dropzone {
    border: 1px dotted #cc0000;
  }

  .placeholder-image {
    padding: 10px;
    cursor: pointer;
  }

  .image {
    @apply relative bg-black pb-2/3 cursor-pointer;
  }

  .image img {
    @apply absolute top-0 w-full h-full object-cover;
  }

  .image .deleteIcon {
    background-color: rgba(0, 0, 0, 0.1);
    @apply absolute w-8 h-8 right-2 bottom-2 rounded-full grid content-center justify-center;
  }
  .image .deleteIcon:hover {
    background-color: rgba(0, 0, 0, 1);
  }

  .img-url-entry {
    padding: 10px;
  }
  .img-url-entry input {
    box-sizing: border-box;
    margin-bottom: 10px;
    padding: 5px;
    width: 100%;
  }
</style>
